// import React, { useState, useEffect, useRef } from 'react';
// import { db, Storage, auth } from '../firebase';
// import { ref, uploadBytes, getDownloadURL} from 'firebase/storage';
// import { setDoc, doc, collection,serverTimestamp, getDoc } from 'firebase/firestore';
// import { useLocation, useNavigate } from 'react-router-dom';

// import 'react-circular-progressbar/dist/styles.css';
// import '../style/DesignUpload.css';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Canvas, Rect, Image as FabricImage } from 'fabric';
// import { PDFDocument } from 'pdf-lib';
// import Sidebar from '../components/Sidebar';
// import Header from '../components/Header';
// import Modal from '../components/Modal';
// import {  FaTimes, FaTrash, FaUndo } from 'react-icons/fa';

// // Local product data
// const PRODUCT_DATA = {
//   "id": 1,
//   "name": "Mailer Bag",
//   "images": ["190GSMWhite.jpg"],
//   "BASE_COST": 235,
//   "tax": "tax",
//   "mockups": ["190GSMWhite.jpg"],
//   "sizes": ["Small", "Medium", "Large", "XL"],
//   "costStructure": {
//     "DTF Epson": {
//       "logo": 36,
//       "LessthenA4": 66,
//       "A4less": 102,
//       "A4": 90,
//       "A3": 120,
//       "full": 150
//     }
//   },
//   "clippingRects": {
//     "front": { "left": 540, "top": 690, "width": 1120, "height": 1400 },
//     "back": { "left": 540, "top": 690, "width": 1120, "height": 1400 }
//   },
//   "sizeChart": "size-chart.jpg"
// };

// const DesignBranding= () => {
//   const location = useLocation();
//   const product = PRODUCT_DATA; // Use local product data
//   const frontCanvasRef = useRef(null);
//   const backCanvasRef = useRef(null);
//   const [frontCanvas, setFrontCanvas] = useState(null);
//   const [backCanvas, setBackCanvas] = useState(null);
//   const [designImages, setDesignImages] = useState({ frontDesignImage: null, backDesignImage: null });
//   const [view, setView] = useState(0); 
//   const [designName, setDesignName] = useState('');
//   const [designFileNames, setDesignFileNames] = useState({ frontDesignImage: '', backDesignImage: '' });
//   const [frontDesignSize, setFrontDesignSize] = useState({ width: 0, height: 0 });
//   const [backDesignSize, setBackDesignSize] = useState({ width: 0, height: 0 });
//   const [frontDesignCost, setFrontDesignCost] = useState(0);
//   const [backDesignCost, setBackDesignCost] = useState(0);
//   const [progress, setProgress] = useState(0);
//   const [sellingPrice, setSellingPrice] = useState('');
//   const [totalPrice, setTotalPrice] = useState(0);
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [userShop, setUserShop] = useState(null);
//   const productName = product.name;
//   const sizes= product.sizes;
//   const tax= product.tax;
//   const baseCost= product.BASE_COST; 
//   const [errors, setErrors] = useState({
//     designName: '',
//     sellingPrice: '',
//     designImages: '',
//   });

//   const [showModal, setShowModal] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false); 
//   const queryParams = new URLSearchParams(location.search);
//   const shop = queryParams.get('shop'); 
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false); 

//   const user = auth.currentUser;
//   if (!user) {
//     throw new Error("User not logged in");
//   }

//   useEffect(() => {
//     const initCanvas = (ref) => {
//       return new Canvas(ref.current, {
//         width: 2200,
//         height: 2700,
//         backgroundColor: "#fff",
//         enableRetinaScaling: false
//       });
//     };

//     const frontFabricCanvas = initCanvas(frontCanvasRef);
//     const backFabricCanvas = initCanvas(backCanvasRef);

//     setFrontCanvas(frontFabricCanvas);
//     setBackCanvas(backFabricCanvas);

//     return () => {
//       frontFabricCanvas.dispose();
//       backFabricCanvas.dispose();
//     };
//   }, []);



//   useEffect(() => {
//     const loadMockupAndTexture = async (canvas, viewIndex) => {
//       if (product) {
//         try {
//           const img = await FabricImage.fromURL(product.mockups[viewIndex]);
//           canvas.set("backgroundImage", img);
//           img.scaleToWidth(canvas.width);
//           img.scaleToHeight(canvas.height);
//           canvas.renderAll();

//           const clippingRects = viewIndex === 0 ? [
//             new Rect({  
//               left: product.clippingRects.front.left,
//               top: product.clippingRects.front.top,
//               width: product.clippingRects.front.width,
//               height: product.clippingRects.front.height,
//               selectable: false,
//               evented: false,
//               stroke: 'red',
//               strokeWidth: 5,
//               strokeDashArray: [4, 4],
//               fill: 'rgba(0,0,0,0)',
//               id: 'clippingRectFront',
//               absolutePositioned: true,
//             })
//           ] : [
//             new Rect({ 
//               left: product.clippingRects.back.left,
//               top: product.clippingRects.back.top,
//               width: product.clippingRects.back.width,
//               height: product.clippingRects.back.height,
//               selectable: false,
//               evented: false,
//               stroke: 'blue',
//               strokeWidth: 5,
//               strokeDashArray: [4, 4],
//               fill: 'rgba(0,0,0,0)',
//               id: 'clippingRectBack', 
//               absolutePositioned: true,
//             }),
//           ];

//           clippingRects.forEach((rect) => canvas.add(rect));
//           canvas.clipPaths = clippingRects;
//           canvas.renderAll();
//         } catch (error) {
//           console.error("Error loading mockup image:", error);
//         }
//       }
//     };

//     if (frontCanvas) loadMockupAndTexture(frontCanvas, 0);
//     if (backCanvas) loadMockupAndTexture(backCanvas, 1);
//   }, [product, frontCanvas, backCanvas]);

//   useEffect(() => {
//     const totalCost = frontDesignCost + backDesignCost;
//     const calculatedTotalPrice = product.BASE_COST + totalCost; 
//     setTotalPrice(calculatedTotalPrice);
//   }, [frontDesignCost, backDesignCost, product.BASE_COST]);

//   const handleSellingPriceChange = (e) => {
//     setSellingPrice(e.target.value);
//   };

//   const updateCostAndSize = (widthUnits, heightUnits, isFront) => {
//     const area = widthUnits * heightUnits;
//     let newCost = 0;
  
//     // Max size is 11 x 13 inches
//     const maxWidth = 11;
//     const maxHeight = 13;

//     // Only update the cost and size for the front or back design if necessary
//     if (isFront) {
//       setFrontDesignSize({ width: widthUnits, height: heightUnits });
//       setFrontDesignCost(newCost);
//     } else {
//       setBackDesignSize({ width: widthUnits, height: heightUnits });
//       setBackDesignCost(newCost);
//     }

//     return newCost;
//   };


// // 1. Load PDF.js dynamically
// const loadPdfJs = () => {
//   return new Promise((resolve, reject) => {
//     if (window.pdfjsLib) {
//       resolve(window.pdfjsLib);
//       return;
//     }

//     const script = document.createElement('script');
//     script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
//     script.onload = () => {
//       window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
//       resolve(window.pdfjsLib);
//     };
//     script.onerror = reject;
//     document.head.appendChild(script);
//   });
// };

// // 2. Convert PDF to image
// const convertPdfToImage = async (pdfFile) => {
//   try {
//     const pdfjsLib = await loadPdfJs();
//     const arrayBuffer = await pdfFile.arrayBuffer();
//     const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
//     const page = await pdf.getPage(1);
    
//     const scale = 2.0;
//     const viewport = page.getViewport({ scale });
    
//     const canvas = document.createElement('canvas');
//     const context = canvas.getContext('2d');
//     canvas.width = viewport.width;
//     canvas.height = viewport.height;
    
//     await page.render({
//       canvasContext: context,
//       viewport: viewport
//     }).promise;
    
//     return canvas.toDataURL('image/png', 1.0);
    
//   } catch (error) {
//     console.error('PDF conversion error:', error);
    
//     // Create placeholder
//     const canvas = document.createElement('canvas');
//     const ctx = canvas.getContext('2d');
//     canvas.width = 800;
//     canvas.height = 1000;
    
//     ctx.fillStyle = '#ffffff';
//     ctx.fillRect(0, 0, canvas.width, canvas.height);
//     ctx.strokeStyle = '#cccccc';
//     ctx.lineWidth = 2;
//     ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);
    
//     ctx.fillStyle = '#666666';
//     ctx.font = 'bold 48px Arial';
//     ctx.textAlign = 'center';
//     ctx.fillText('📄', canvas.width / 2, canvas.height / 2 - 50);
//     ctx.font = '24px Arial';
//     ctx.fillText('PDF Document', canvas.width / 2, canvas.height / 2 + 20);
    
//     return canvas.toDataURL('image/png', 1.0);
//   }
// };

// // 3. Replace your existing handleFileUpload function completely
// const handleFileUpload = async (e) => {
//   const file = e.target.files[0];
//   const activeCanvas = view === 0 ? frontCanvas : backCanvas;

//   if (!file || !file.type.includes("pdf")) {
//     toast.error("Please upload a PDF file.");
//     return;
//   }

//   setIsLoading(true);

//   try {
//     const designType = view === 0 ? "front" : "back";
    
//     // Update UI immediately
//     setDesignFileNames((prev) => ({
//       ...prev,
//       [`${designType}DesignImage`]: file.name,
//     }));

//     setDesignImages((prev) => ({
//       ...prev,
//       [`${designType}DesignImage`]: file,
//     }));

//     // Convert PDF to image
//     const imageDataUrl = await convertPdfToImage(file);

//     // Upload PDF to Firebase
//     const timestamp = Date.now();
//     const fileRef = ref(Storage, `designs/${designType}-${timestamp}.pdf`);
//     await uploadBytes(fileRef, file);
//     const designImageUrl = await getDownloadURL(fileRef);
    
//     setDesignImages((prev) => ({
//       ...prev,
//       [`${designType}DesignImageUrl`]: designImageUrl,
//     }));

//     // Create and add fabric image
//     const fabricImg = await FabricImage.fromURL(imageDataUrl);
    
//     if (!fabricImg.width || !fabricImg.height) {
//       throw new Error("Failed to create image from PDF");
//     }

//     // Remove existing design objects
//     const existingObjects = activeCanvas.getObjects().filter(obj => 
//       obj.type === 'image' && obj !== activeCanvas.backgroundImage
//     );
//     existingObjects.forEach(obj => activeCanvas.remove(obj));

//     // Setup clipping and positioning
//     const maxWidth = 11;
//     const maxHeight = 13;
//     const clippingRect = designType === "front" ? product.clippingRects.front : product.clippingRects.back;
    
//     const scaleFactor = Math.min(
//       clippingRect.width / fabricImg.width,
//       clippingRect.height / fabricImg.height,
//       1
//     );

//     fabricImg.scale(scaleFactor);

//     const clipPath = new Rect({
//       left: clippingRect.left,
//       top: clippingRect.top,
//       width: clippingRect.width,
//       height: clippingRect.height,
//       absolutePositioned: true,
//     });

//     const scaledWidth = fabricImg.width * scaleFactor;
//     const scaledHeight = fabricImg.height * scaleFactor;
    
//     fabricImg.set({
//       left: clippingRect.left + (clippingRect.width - scaledWidth) / 2,
//       top: clippingRect.top + (clippingRect.height - scaledHeight) / 2,
//       clipPath: clipPath,
//     });

//     // Add to canvas
//     activeCanvas.add(fabricImg);
//     activeCanvas.setActiveObject(fabricImg);

//     // Setup controls
//     fabricImg.setControlsVisibility({
//       mt: false, mb: false, ml: false, mr: false,
//       tl: true, tr: true, bl: true, br: true
//     });

//     fabricImg.set({
//       cornerSize: 30,
//       borderWidth: 3,
//       borderColor: '#2196F3',
//       cornerColor: '#2196F3',
//       cornerStrokeColor: '#1976D2',
//       transparentCorners: false
//     });

//     // Calculate cost
//     const widthInInches = scaledWidth / (clippingRect.width / maxWidth);
//     const heightInInches = scaledHeight / (clippingRect.height / maxHeight);
//     updateCostAndSize(widthInInches, heightInInches, designType === "front");

//     // Event handlers
//     fabricImg.on('scaling', function() {
//       const obj = this;
//       const newScaledWidth = obj.width * obj.scaleX;
//       const newScaledHeight = obj.height * obj.scaleY;
      
//       const newWidthInInches = newScaledWidth / (clippingRect.width / maxWidth);
//       const newHeightInInches = newScaledHeight / (clippingRect.height / maxHeight);
      
//       updateCostAndSize(newWidthInInches, newHeightInInches, designType === "front");
//     });

//     fabricImg.on('scaled', function() {
//       const obj = this;
//       obj.set({
//         width: obj.width * obj.scaleX,
//         height: obj.height * obj.scaleY,
//         scaleX: 1,
//         scaleY: 1
//       });
//       obj.setCoords();
//     });

//     activeCanvas.renderAll();
//     toast.success("PDF uploaded successfully!");

//   } catch (error) {
//     console.error("Error processing PDF:", error);
//     toast.error(`Error processing PDF: ${error.message}`);
//   } finally {
//     setIsLoading(false);
//     setDrawerOpen(false);
//   }
// };

// useEffect(() => {
//   const fetchUserShop = async () => {
//     const userDocRef = doc(db, 'users', user.uid);
//     const userDoc = await getDoc(userDocRef);

//     if (!userDoc.exists()) {
//       toast.error("User data not found.");
//       return;
//     }

//     const userData = userDoc.data();
//     const userShop = userData.shop;
//     setUserShop(userShop);
//   };

//   fetchUserShop();
// }, [user.uid]);

// const handleSaveProduct = async () => {
//   const frontImageUrl = designImages.frontDesignImageUrl || null;
//   const backImageUrl = designImages.backDesignImageUrl || null;

//   setErrors({
//     sellingPrice: '',
//     designImages: '',
//   });

//   // Validation
//   let isValid = true;
//   const newErrors = {};

//   if (!designName) {
//     newErrors.designName = 'Design Name is required';
//     isValid = false;
//   }
//   if (!sellingPrice) {
//     newErrors.sellingPrice = 'Selling Price is required';
//     isValid = false;
//   }
//   if (!designImages.frontDesignImage && !designImages.backDesignImage) {
//     newErrors.designImages = 'Please upload at least one design PDF (front or back)';
//     isValid = false;
//   }


//   if (!isValid) {
//     setErrors(newErrors);
//     return;
//   }

//   setIsSubmitting(true);
//   setIsLoading(true);

//   const updateProgress = (percentage) => {
//     setProgress(percentage);
//   };


//  try {
//     // Updated saveCanvasToStorage function
//     const saveCanvasToStorage = async (canvas, canvasName) => {
//       // Hide clipping rectangles
//       const clippingRects = canvas.getObjects('rect').filter(rect => 
//         rect.id && (rect.id.includes('clippingRect') || rect.stroke === 'red' || rect.stroke === 'blue')
//       );
      
//       clippingRects.forEach(rect => rect.set({ visible: false }));
//       canvas.renderAll();
      
//       // Wait for render
//       await new Promise(resolve => setTimeout(resolve, 200));
      
//       // Export canvas
//       const dataURL = canvas.toDataURL({
//         format: 'png',
//         quality: 1.0,
//         multiplier: 2
//       });
      
//       // Convert to blob
//       const response = await fetch(dataURL);
//       const blob = await response.blob();
      
//       // Upload
//       const timestamp = Date.now();
//       const storageRef = ref(Storage, `mockups/${designName}-${canvasName}-${timestamp}.png`);
//       await uploadBytes(storageRef, blob);
//       const downloadURL = await getDownloadURL(storageRef);
      
//       // Show clipping rects again
//       clippingRects.forEach(rect => rect.set({ visible: true }));
//       canvas.renderAll();
      
//       return downloadURL;
//     };



//     // Generate SKUs for different sizes
//     const generateSKUs = () => {
//       const randomNum = Math.floor(Math.random() * 1000000);
//       const productSizes = product.sizes || [];
//       return productSizes.map(size => `u-${randomNum}-${size}`);
//     };
    
//     const skus = generateSKUs();

//     // Export the final combined design for front and back mockups
//     const frontMockupUrl = await saveCanvasToStorage(frontCanvas, 'front');
//     updateProgress(50);
//     const backMockupUrl = await saveCanvasToStorage(backCanvas, 'back');
//     updateProgress(70);

//     // Create design document in Firestore
//     const designRef = doc(collection(db, 'users', user.uid, 'designs'));
//     await setDoc(designRef, {
//       designName,
//       sellingPrice,
//       totalPrice,
//       frontDesign: frontImageUrl,
//       backDesign: backImageUrl,
//       images: {
//         front: frontMockupUrl,
//         back: backMockupUrl,
//       },
//       costs: {
//         front: frontDesignCost,
//         back: backDesignCost,
//       },
//       Printsizes: {
//         front: frontDesignSize,
//         back: backDesignSize,
//       },
//       productName: product.name,
//       SKUs: skus,
//       baseCost: product.BASE_COST,
//       PrintCost: frontDesignCost + backDesignCost,
//       timestamp: serverTimestamp(),
//       userId: user.uid
//     });

//     toast.success('Design uploaded successfully!');
//     setShowModal(true);
//   } catch (error) {
//     console.error("Error uploading design:", error);
//     toast.error("Failed to upload design.");
//   } finally {
//     setIsSubmitting(false);
//     setIsLoading(false);
//     setProgress(100);
//   }
// };

// const handleGoToProducts = () => {
//   navigate('/products');
// };

//   const handleRotate = () => {
//     const activeCanvas = view === 0 ? frontCanvas : backCanvas;
//     const activeObjects = activeCanvas.getActiveObjects();

//     activeObjects.forEach((obj) => {
//       obj.rotate(obj.angle + 90);
//       obj.setCoords();
//     });
//     activeCanvas.renderAll();
//   };

//   const handleDelete = () => {
//     const activeCanvas = view === 0 ? frontCanvas : backCanvas;
//     const activeObjects = activeCanvas.getActiveObjects();

//     activeObjects.forEach((obj) => {
//       activeCanvas.remove(obj);
//     });
//     activeCanvas.discardActiveObject();
//     activeCanvas.renderAll();

//     if (view === 0) {
//       updateCostAndSize(0, 0, true);
//     } else {
//       updateCostAndSize(0, 0, false);
//     }
//   };


// useEffect(() => {
//   loadPdfJs()
//     .then(() => console.log('PDF.js loaded successfully'))
//     .catch(error => console.error('Failed to load PDF.js:', error));
// }, []);

//   const setOpenDrawer = (isOpen) => {
//     setDrawerOpen(isOpen);
//   };

//   return (
//     <div className="one">
//     <Header/>
//     <div className="design-upload-container">
//     <Sidebar />
//      <div className={`drawer ${drawerOpen ? 'open' : ''}`}>
//      <div className="drawer-header">
//               <button className="close-drawer" onClick={() => setOpenDrawer(false)}>
//                 <FaTimes/>
//               </button>
//             </div>

//       <div className="form-wrapper">
//         <h2 className='hideee'>Design Upload</h2>

//         <form onSubmit={(e) => e.preventDefault()}>
//           <div className="form-group">
// <div className="form-group">
//             <label>Upload Design PDF:</label>
//             <input
//               type="file"
//               accept=".pdf"
//               onChange={handleFileUpload}
//               multiple
//               required
//               style={{ display: 'none' }}
//               id="designImage"
//             />
//             <label htmlFor="designImage" className="custom-file-upload">
//               + Add PDF
//             </label>

// {Object.keys(designFileNames).map((key) => {
//   if (designFileNames[key]) {
//     return (
//       <p key={key}>Uploaded: {designFileNames[key]}</p>
//     );
//   }
//   return null;
// })}
//           </div>
//             <label htmlFor="designName">Product Name:</label>
//             <input
//               type="text"
//               id="designName"
//               value={designName}
//               onChange={(e) => setDesignName(e.target.value)}
//               placeholder="Product Name"
//               required            
//             />
//               {errors.designName && <p className="error">{errors.designName}</p>}
//           </div>
   

//           <div className="design-details">

//             <p><label>Max Design Size: 11 x 13 inches</label></p>
//             <p><label>Front Design Size: {frontDesignSize.width.toFixed(1)} x {frontDesignSize.height.toFixed(1)} inches</label></p>
//             <p><label>Back Design Size: {backDesignSize.width.toFixed(1)} x {backDesignSize.height.toFixed(1)} inches</label></p>
//             <p><label>Total Cost: ₹{totalPrice} + {product.tax} + Shipping </label></p>
//           </div>

//           <div className="form-group">
//             <label htmlFor="sellingPrice">Selling Price:</label>
//             <input
//               type="number"
//               id="sellingPrice"
//               value={sellingPrice}
//               onChange={handleSellingPriceChange}
//               placeholder="Enter Selling Price"
//               required
//             />
//              {errors.sellingPrice && <p className="error">{errors.sellingPrice}</p>}
//           </div>

//           <div className="Beee">
//             <button type="button" disabled={isSubmitting} onClick={handleSaveProduct} className="save-submit">
//               {isSubmitting ? 'Saving Product...' : 'Save Product'}
//             </button>
//           </div>

//           {userShop && (
//             <div className='skualert'>*Do not change the SKU of the Shopify product after creation.</div>
//           )}
//         </form>
//         </div>

//         {showModal && (
//         <Modal>
//           <div className="modal-content">
//             <h2>Your product has been created successfully!</h2>
//             <button onClick={handleGoToProducts}>Go to products page!</button>
//           </div>
//         </Modal>
//       )}
      
//    {isLoading && (
//   <div className="loader-overlay">
//     <img src="Video1.GIF" alt="Loading..." />
//     <span></span>
//     <div className="progress">
//               <p>{progress}%</p> {/* Display progress */}
//         </div>
//   </div>
// )}

//       </div>


//       <div className="mockup">
//       <div className="view-and-customize">
//          <select onChange={(e) => setView(Number(e.target.value))}  className="view-select">
//             <option value="0">Front</option>
//             <option value="1">Back</option>
//           </select>
      
//           <button onClick={() => setOpenDrawer(true)} className="customize-button">
//               Customize
//           </button>
//            <button onClick={handleRotate} className="control-button"><FaUndo/></button>
//           <button  onClick={handleDelete} className="control-button"><FaTrash/></button>
// </div>
//         <div style={{ display: view === 0 ? 'block' : 'none' }}>
//         <div className="canvas-wrapper">
//           <canvas ref={frontCanvasRef} />
//           </div>
//         </div>
//         <div style={{ display: view === 1 ? 'block' : 'none' }}>
//         <div className="canvas-wrapper">
//           <canvas ref={backCanvasRef} />
//           </div>
//         </div>
        
//       </div>
      
//     </div>
//     </div>
//   );
// };

// export default DesignBranding;


import React, { useState, useEffect, useRef } from 'react';
import { db, Storage, auth } from '../firebase';
import { ref, uploadBytes, getDownloadURL} from 'firebase/storage';
import { setDoc, doc, collection,serverTimestamp, getDoc } from 'firebase/firestore';
import { useLocation, useNavigate } from 'react-router-dom';

import 'react-circular-progressbar/dist/styles.css';
import '../style/DesignUpload.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Canvas, Rect, Image as FabricImage } from 'fabric';
import { PDFDocument } from 'pdf-lib';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Modal from '../components/Modal';
import { FaTimes, FaTrash, FaUndo } from 'react-icons/fa';

// Local product data - Updated with different mockups for different sizes
const PRODUCT_DATA = {
  "id": 1,
  "name": "Mailer Bag",
  "images": {
    "black": "190GSMBlack.jpg",
    "white": "190GSMWhite.jpg"
  },
  "BASE_COST": 235,
  "PRINT_COST": 20, // Fixed print cost
  "tax": "tax",
  "mockups": {
    // Small size mockups
    "small": {
      "black": "190GSMBlack.jpg",
      "white": "190GSMWhite.jpg"
    },
    // Large size mockups - you need to replace these with actual large mockup images
    "large": {
      "black": "190GSMBlack.jpg",
      "white": "190GSMWhite.jpg"
    }
  },
  "sizes": ["Small", "Large"],
  "costStructure": {
    "DTF Epson": {
      "logo": 36,
      "LessthenA4": 66,
      "A4less": 102,
      "A4": 90,
      "A3": 120,
      "full": 150
    }
  },
  "clippingRects": {
    "small": { "left": 540, "top": 690, "width": 1120, "height": 1400 },
    "large": { "left": 540, "top": 690, "width": 1430, "height": 1730 }
  },
  "sizeChart": "size-chart.jpg"
};

const DesignBranding = () => {
  const location = useLocation();
  const product = PRODUCT_DATA;
  const frontCanvasRef = useRef(null);
  const [frontCanvas, setFrontCanvas] = useState(null);
  const [designImages, setDesignImages] = useState({ frontDesignImage: null });
  const [designName, setDesignName] = useState('');
  const [designFileNames, setDesignFileNames] = useState({ frontDesignImage: '' });
  const [frontDesignSize, setFrontDesignSize] = useState({ width: 0, height: 0 });
  const [frontDesignCost, setFrontDesignCost] = useState(0);
  const [progress, setProgress] = useState(0);
  const [sellingPrice, setSellingPrice] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [userShop, setUserShop] = useState(null);
  const [selectedSize, setSelectedSize] = useState('Small');
  const [selectedColor, setSelectedColor] = useState('Black');
  const productName = product.name;
  const sizes = product.sizes;
  const tax = product.tax;
  const baseCost = product.BASE_COST;
  const printCost = product.PRINT_COST;
  const [errors, setErrors] = useState({
    designName: '',
    sellingPrice: '',
    designImages: '',
  });

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const shop = queryParams.get('shop');
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not logged in");
  }

  // Get max print size based on selected size
  const getMaxPrintSize = () => {
    return selectedSize === 'Small' ? { width: 11, height: 13 } : { width: 14, height: 16 };
  };

  useEffect(() => {
    const initCanvas = (ref) => {
      return new Canvas(ref.current, {
        width: 2200,
        height: 2700,
        backgroundColor: "#fff",
        enableRetinaScaling: false
      });
    };

    const frontFabricCanvas = initCanvas(frontCanvasRef);
    setFrontCanvas(frontFabricCanvas);

    return () => {
      frontFabricCanvas.dispose();
    };
  }, []);

  useEffect(() => {
    const loadMockupAndTexture = async (canvas) => {
      if (product) {
        try {
          const colorKey = selectedColor.toLowerCase();
          const sizeKey = selectedSize.toLowerCase();
          
          // Get mockup image based on size and color
          const mockupImage = product.mockups[sizeKey][colorKey];
          const img = await FabricImage.fromURL(mockupImage);
          canvas.set("backgroundImage", img);
          img.scaleToWidth(canvas.width);
          img.scaleToHeight(canvas.height);
          canvas.renderAll();

          // Remove existing clipping rectangles
          const existingClippingRects = canvas.getObjects('rect').filter(rect => 
            rect.id && rect.id.includes('clippingRect')
          );
          existingClippingRects.forEach(rect => canvas.remove(rect));

          const clippingRect = new Rect({
            left: product.clippingRects[sizeKey].left,
            top: product.clippingRects[sizeKey].top,
            width: product.clippingRects[sizeKey].width,
            height: product.clippingRects[sizeKey].height,
            selectable: false,
            evented: false,
            stroke: 'red',
            strokeWidth: 5,
            strokeDashArray: [4, 4],
            fill: 'rgba(0,0,0,0)',
            id: 'clippingRectFront',
            absolutePositioned: true,
          });

          canvas.add(clippingRect);
          canvas.clipPaths = [clippingRect];
          canvas.renderAll();
        } catch (error) {
          console.error("Error loading mockup image:", error);
          // Fallback to old mockup structure if new structure fails
          try {
            const colorKey = selectedColor.toLowerCase();
            const mockupImage = product.mockups[colorKey] || product.images[colorKey];
            const img = await FabricImage.fromURL(mockupImage);
            canvas.set("backgroundImage", img);
            img.scaleToWidth(canvas.width);
            img.scaleToHeight(canvas.height);
            canvas.renderAll();
          } catch (fallbackError) {
            console.error("Fallback mockup loading also failed:", fallbackError);
          }
        }
      }
    };

    if (frontCanvas) loadMockupAndTexture(frontCanvas);
  }, [product, frontCanvas, selectedColor, selectedSize]);

  // Updated useEffect to include print cost in total calculation
  useEffect(() => {
    const calculatedTotalPrice = product.BASE_COST + product.PRINT_COST;
    setTotalPrice(calculatedTotalPrice);
    setFrontDesignCost(product.PRINT_COST); // Set the fixed print cost
  }, [product.BASE_COST, product.PRINT_COST]);

  const handleSellingPriceChange = (e) => {
    setSellingPrice(e.target.value);
  };

  // Simplified updateCostAndSize function since we're using fixed cost
  const updateCostAndSize = (widthUnits, heightUnits) => {
    setFrontDesignSize({ width: widthUnits, height: heightUnits });
    // Cost remains fixed at ₹20
    setFrontDesignCost(product.PRINT_COST);
    return product.PRINT_COST;
  };

  // Load PDF.js dynamically
  const loadPdfJs = () => {
    return new Promise((resolve, reject) => {
      if (window.pdfjsLib) {
        resolve(window.pdfjsLib);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      script.onload = () => {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
        resolve(window.pdfjsLib);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  // Convert PDF to image
  const convertPdfToImage = async (pdfFile) => {
    try {
      const pdfjsLib = await loadPdfJs();
      const arrayBuffer = await pdfFile.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      const page = await pdf.getPage(1);
      
      const scale = 2.0;
      const viewport = page.getViewport({ scale });
      
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      
      await page.render({
        canvasContext: context,
        viewport: viewport
      }).promise;
      
      return canvas.toDataURL('image/png', 1.0);
      
    } catch (error) {
      console.error('PDF conversion error:', error);
      
      // Create placeholder
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 800;
      canvas.height = 1000;
      
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = '#cccccc';
      ctx.lineWidth = 2;
      ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);
      
      ctx.fillStyle = '#666666';
      ctx.font = 'bold 48px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('📄', canvas.width / 2, canvas.height / 2 - 50);
      ctx.font = '24px Arial';
      ctx.fillText('PDF Document', canvas.width / 2, canvas.height / 2 + 20);
      
      return canvas.toDataURL('image/png', 1.0);
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const activeCanvas = frontCanvas;

    if (!file || !file.type.includes("pdf")) {
      toast.error("Please upload a PDF file.");
      return;
    }

    setIsLoading(true);

    try {
      // Update UI immediately
      setDesignFileNames({ frontDesignImage: file.name });
      setDesignImages({ frontDesignImage: file });

      // Convert PDF to image
      const imageDataUrl = await convertPdfToImage(file);

      // Upload PDF to Firebase
      const timestamp = Date.now();
      const fileRef = ref(Storage, `BrandingImages/MailerBag/front-${timestamp}.pdf`);
      await uploadBytes(fileRef, file);
      const designImageUrl = await getDownloadURL(fileRef);
      
      setDesignImages((prev) => ({
        ...prev,
        frontDesignImageUrl: designImageUrl,
      }));

      // Create and add fabric image
      const fabricImg = await FabricImage.fromURL(imageDataUrl);
      
      if (!fabricImg.width || !fabricImg.height) {
        throw new Error("Failed to create image from PDF");
      }

      // Remove existing design objects
      const existingObjects = activeCanvas.getObjects().filter(obj => 
        obj.type === 'image' && obj !== activeCanvas.backgroundImage
      );
      existingObjects.forEach(obj => activeCanvas.remove(obj));

      // Setup clipping and positioning
      const maxSize = getMaxPrintSize();
      const sizeKey = selectedSize.toLowerCase();
      const clippingRect = product.clippingRects[sizeKey];
      
      const scaleFactor = Math.min(
        clippingRect.width / fabricImg.width,
        clippingRect.height / fabricImg.height,
        1
      );

      fabricImg.scale(scaleFactor);

      const clipPath = new Rect({
        left: clippingRect.left,
        top: clippingRect.top,
        width: clippingRect.width,
        height: clippingRect.height,
        absolutePositioned: true,
      });

      const scaledWidth = fabricImg.width * scaleFactor;
      const scaledHeight = fabricImg.height * scaleFactor;
      
      fabricImg.set({
        left: clippingRect.left + (clippingRect.width - scaledWidth) / 2,
        top: clippingRect.top + (clippingRect.height - scaledHeight) / 2,
        clipPath: clipPath,
      });

      // Add to canvas
      activeCanvas.add(fabricImg);
      activeCanvas.setActiveObject(fabricImg);

      // Setup controls
      fabricImg.setControlsVisibility({
        mt: false, mb: false, ml: false, mr: false,
        tl: true, tr: true, bl: true, br: true
      });

      fabricImg.set({
        cornerSize: 30,
        borderWidth: 3,
        borderColor: '#2196F3',
        cornerColor: '#2196F3',
        cornerStrokeColor: '#1976D2',
        transparentCorners: false
      });

      // Calculate cost - now uses fixed print cost
      const widthInInches = scaledWidth / (clippingRect.width / maxSize.width);
      const heightInInches = scaledHeight / (clippingRect.height / maxSize.height);
      updateCostAndSize(widthInInches, heightInInches);

      // Event handlers - simplified since cost is fixed
      fabricImg.on('scaling', function() {
        const obj = this;
        const newScaledWidth = obj.width * obj.scaleX;
        const newScaledHeight = obj.height * obj.scaleY;
        
        const newWidthInInches = newScaledWidth / (clippingRect.width / maxSize.width);
        const newHeightInInches = newScaledHeight / (clippingRect.height / maxSize.height);
        
        updateCostAndSize(newWidthInInches, newHeightInInches);
      });

      fabricImg.on('scaled', function() {
        const obj = this;
        obj.set({
          width: obj.width * obj.scaleX,
          height: obj.height * obj.scaleY,
          scaleX: 1,
          scaleY: 1
        });
        obj.setCoords();
      });

      activeCanvas.renderAll();
      toast.success("PDF uploaded successfully!");

    } catch (error) {
      console.error("Error processing PDF:", error);
      toast.error(`Error processing PDF: ${error.message}`);
    } finally {
      setIsLoading(false);
      setDrawerOpen(false);
    }
  };

  useEffect(() => {
    const fetchUserShop = async () => {
      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);

      if (!userDoc.exists()) {
        toast.error("User data not found.");
        return;
      }

      const userData = userDoc.data();
      const userShop = userData.shop;
      setUserShop(userShop);
    };

    fetchUserShop();
  }, [user.uid]);

  const handleSaveProduct = async () => {
    const frontImageUrl = designImages.frontDesignImageUrl || null;

    setErrors({
      designName: '',
      sellingPrice: '',
      designImages: '',
    });

    // Validation
    let isValid = true;
    const newErrors = {};

    if (!designName) {
      newErrors.designName = 'Design Name is required';
      isValid = false;
    }

    if (!designImages.frontDesignImage) {
      newErrors.designImages = 'Please upload a design PDF';
      isValid = false;
    }

    if (!isValid) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    setIsLoading(true);

    const updateProgress = (percentage) => {
      setProgress(percentage);
    };

    try {
      // Save canvas to storage
      const saveCanvasToStorage = async (canvas, canvasName) => {
        // Hide clipping rectangles
        const clippingRects = canvas.getObjects('rect').filter(rect => 
          rect.id && (rect.id.includes('clippingRect') || rect.stroke === 'red')
        );
        
        clippingRects.forEach(rect => rect.set({ visible: false }));
        canvas.renderAll();
        
        // Wait for render
        await new Promise(resolve => setTimeout(resolve, 200));
        
        // Export canvas
        const dataURL = canvas.toDataURL({
          format: 'png',
          quality: 1.0,
          multiplier: 2
        });
        
        // Convert to blob
        const response = await fetch(dataURL);
        const blob = await response.blob();
        
        // Upload
        const timestamp = Date.now();
        const storageRef = ref(Storage, `BrandingMockups/${designName}-${canvasName}-${timestamp}.png`);
        await uploadBytes(storageRef, blob);
        const downloadURL = await getDownloadURL(storageRef);
        
        // Show clipping rects again
        clippingRects.forEach(rect => rect.set({ visible: true }));
        canvas.renderAll();
        
        return downloadURL;
      };

      // Generate SKU with color and size
      const generateSKU = () => {
        const randomNum = Math.floor(Math.random() * 1000000);
        return `u-${randomNum}-${selectedSize}-${selectedColor}`;
      };
      
      const sku = generateSKU();

      // Export the final combined design for front mockup
      const frontMockupUrl = await saveCanvasToStorage(frontCanvas, 'front');
      updateProgress(70);

      // Create design document in Firestore
      const BrandingRef = doc(collection(db, 'users', user.uid, 'BrandingDesigns'));
      await setDoc(BrandingRef, {
        designName,
        totalPrice,
        frontDesign: frontImageUrl,
        size: selectedSize,
        color: selectedColor,
        images: {
          front: frontMockupUrl,
        },
        costs: {
          front: frontDesignCost,
        },
        Printsizes: {
          front: frontDesignSize,
        },
        productName: product.name,
        SKU: sku,
        baseCost: product.BASE_COST,
        PrintCost: frontDesignCost,
        timestamp: serverTimestamp(),
        userId: user.uid
      });

      toast.success('Design uploaded successfully!');
      setShowModal(true);
    } catch (error) {
      console.error("Error uploading design:", error);
      toast.error("Failed to upload design.");
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
      setProgress(100);
    }
  };

  const handleGoToProducts = () => {
    navigate('/branding-elements');
  };

  const handleRotate = () => {
    const activeCanvas = frontCanvas;
    const activeObjects = activeCanvas.getActiveObjects();

    activeObjects.forEach((obj) => {
      obj.rotate(obj.angle + 90);
      obj.setCoords();
    });
    activeCanvas.renderAll();
  };

  const handleDelete = () => {
    const activeCanvas = frontCanvas;
    const activeObjects = activeCanvas.getActiveObjects();

    activeObjects.forEach((obj) => {
      activeCanvas.remove(obj);
    });
    activeCanvas.discardActiveObject();
    activeCanvas.renderAll();

    updateCostAndSize(0, 0);
  };

  useEffect(() => {
    loadPdfJs()
      .then(() => console.log('PDF.js loaded successfully'))
      .catch(error => console.error('Failed to load PDF.js:', error));
  }, []);

  const setOpenDrawer = (isOpen) => {
    setDrawerOpen(isOpen);
  };

  const maxSize = getMaxPrintSize();

  return (
    <div className="one">
      <Header/>
      <div className="design-upload-container">
        <Sidebar />
        <div className={`drawer ${drawerOpen ? 'open' : ''}`}>
          <div className="drawer-header">
            <button className="close-drawer" onClick={() => setOpenDrawer(false)}>
              <FaTimes/>
            </button>
          </div>

          <div className="form-wrapper">
            <h2 className='hideee'>Design Upload</h2>

            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group">
                <label>Upload Design PDF:</label>
                <input
                  type="file"
                  accept=".pdf"
                  onChange={handleFileUpload}
                  required
                  style={{ display: 'none' }}
                  id="designImage"
                />
                <label htmlFor="designImage" className="custom-file-upload">
                  + Add PDF
                </label>

                {designFileNames.frontDesignImage && (
                  <p>Uploaded: {designFileNames.frontDesignImage}</p>
                )}

                {/* Size Selection */}
                <div className="size-selection" style={{ marginTop: '15px' }}>
                  <label>Size:</label>
                  <div className="size-buttons" style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                    <button
                      type="button"
                      className={`size-button ${selectedSize === 'Small' ? 'active' : ''}`}
                      onClick={() => setSelectedSize('Small')}
                      style={{
                        padding: '8px 16px',
                        border: selectedSize === 'Small' ? '2px solid #007bff' : '1px solid #ccc',
                        backgroundColor: selectedSize === 'Small' ? '#007bff' : '#fff',
                        color: selectedSize === 'Small' ? '#fff' : '#000',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Small
                    </button>
                    <button
                      type="button"
                      className={`size-button ${selectedSize === 'Large' ? 'active' : ''}`}
                      onClick={() => setSelectedSize('Large')}
                      style={{
                        padding: '8px 16px',
                        border: selectedSize === 'Large' ? '2px solid #007bff' : '1px solid #ccc',
                        backgroundColor: selectedSize === 'Large' ? '#007bff' : '#fff',
                        color: selectedSize === 'Large' ? '#fff' : '#000',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Large
                    </button>
                  </div>
                </div>

                {/* Color Selection */}
                <div className="color-selection" style={{ marginTop: '15px' }}>
                  <label>Color:</label>
                  <div className="color-buttons" style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                    <button
                      type="button"
                      className={`color-button ${selectedColor === 'White' ? 'active' : ''}`}
                      onClick={() => setSelectedColor('White')}
                      style={{
                        padding: '8px 16px',
                        border: selectedColor === 'White' ? '2px solid #007bff' : '1px solid #ccc',
                        backgroundColor: selectedColor === 'White' ? '#007bff' : '#fff',
                        color: selectedColor === 'White' ? '#fff' : '#000',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      White
                    </button>
                    <button
                      type="button"
                      className={`color-button ${selectedColor === 'Black' ? 'active' : ''}`}
                      onClick={() => setSelectedColor('Black')}
                      style={{
                        padding: '8px 16px',
                        border: selectedColor === 'Black' ? '2px solid #007bff' : '1px solid #ccc',
                        backgroundColor: selectedColor === 'Black' ? '#333' : '#fff',
                        color: selectedColor === 'Black' ? '#fff' : '#000',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Black
                    </button>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="designName">Product Name:</label>
                <input
                  type="text"
                  id="designName"
                  value={designName}
                  onChange={(e) => setDesignName(e.target.value)}
                  placeholder="Product Name"
                  required            
                />
                {errors.designName && <p className="error">{errors.designName}</p>}
              </div>

              <div className="design-details">
                <p><label>Max Design Size: {maxSize.width} x {maxSize.height} inches</label></p>
                <p><label>Front Design Size: {frontDesignSize.width.toFixed(1)} x {frontDesignSize.height.toFixed(1)} inches</label></p>
                <p><label>Print Cost: ₹{printCost}</label></p>
                <p><label>Cost Per Piece: ₹{totalPrice} + {product.tax}</label></p>
              </div>


              <div className="Beee">
                <button type="button" disabled={isSubmitting} onClick={handleSaveProduct} className="save-submit">
                  {isSubmitting ? 'Saving Product...' : 'Save Product'}
                </button>
              </div>

              {userShop && (
                <div className='skualert'>*Do not change the SKU of the Shopify product after creation.</div>
              )}
            </form>
          </div>

          {showModal && (
            <Modal>
              <div className="modal-content">
                <h2>Your product has been created successfully!</h2>
                <button onClick={handleGoToProducts}>Go to products page!</button>
              </div>
            </Modal>
          )}
          
          {isLoading && (
            <div className="loader-overlay">
              <img src="Video1.GIF" alt="Loading..." />
              <span></span>
              <div className="progress">
                <p>{progress}%</p>
              </div>
            </div>
          )}
        </div>

        <div className="mockup">
          <div className="view-and-customize">
            <button onClick={() => setOpenDrawer(true)} className="customize-button">
              Customize
            </button>
            <button onClick={handleRotate} className="control-button"><FaUndo/></button>
            <button onClick={handleDelete} className="control-button"><FaTrash/></button>
          </div>
          
          <div className="canvas-wrapper">
            <canvas ref={frontCanvasRef} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignBranding;